// extracted by mini-css-extract-plugin
module.exports = {"upcomingEpisode":"fy","comingSoon":"fz","isRental":"fA","startDate":"fB","upcomingTitle":"fC","comingSoonTitle":"fD","startDateTitle":"fE","available":"fF"};